import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.DiseasedTrees;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "DiseasedTrees.Phaser.IntroductionScene.1",
            "DiseasedTrees.Phaser.IntroductionScene.2",
            "DiseasedTrees.Phaser.IntroductionScene.3",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/DiseasedTreesGame/scenes/GameIntro.ts